{
  "common.close": "Fechar",
  "common.athleteFallback": "atleta {id}",
  "splash.title": "{app} — visualização animada de atividades",
  "splash.tagline": "Os seus dados do Strava&nbsp;em movimento",
  "splash.demo": "Demonstração",
  "tab.query.title": "Mapa de {name}",
  "tab.query.heading": "Consulta de atividades:",
  "tab.query.optDays": "últimos dias",
  "tab.query.optActivities": "últimas atividades",
  "tab.query.optIds": "IDs de atividades",
  "tab.query.optDates": "Intervalo de datas",
  "tab.query.idsPlaceholder": "introduza aqui os IDs das atividades",
  "tab.query.after": "De:",
  "tab.query.before": "Até:",
  "tab.query.autozoom": "Ampliar automaticamente <i class=\"hf hf-bullseye\"></i> para a consulta após importar",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Consultar",
  "tab.query.createAccount": "Crie uma conta ou inicie sessão.",
  "tab.query.sports": "Desportos:",
  "tab.query.allSports": "Todos os desportos",
  "tab.query.sportsExcept": "Todos exceto",
  "tab.query.sportsNone": "Nenhum",
  "tab.query.loadingSports": "A carregar desportos…",
  "tab.query.sportsFailed": "Não foi possível carregar os desportos deste mapa",
  "tab.query.noSports": "Ainda não há atividades",
  "tab.activities.title": "Atividades apresentadas",
  "tab.activities.clearSelection": "Limpar seleção",
  "tab.activities.renderSelected": "Mostrar seleção",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Ampliar para a seleção",
  "tab.controls.title": "Definições da camada",
  "tab.controls.timescale": "Escala de tempo <i>&tau;</i>",
  "tab.controls.timescaleHint": "velocidade de reprodução",
  "tab.controls.period": "Período <i>T</i>",
  "tab.controls.periodHint": "atividade ~ modelo",
  "tab.controls.dotSize": "Tamanho dos pontos",
  "tab.controls.pathWidth": "Espessura do traçado",
  "tab.controls.pathWidthHint": "zero oculta os traçados",
  "tab.controls.colors": "Cores",
  "tab.controls.colorsHint": "rodar a paleta",
  "tab.controls.shadows": "Sombras",
  "tab.profile.loginTitle": "Iniciar sessão",
  "tab.profile.anonNote": "Inicie sessão com o Strava para ver as suas próprias atividades e gerir a sua conta Heatflask.",
  "tab.profile.loginLink": "Iniciar sessão com o Strava",
  "tab.profile.editOnStrava": "Editar o seu perfil no Strava",
  "tab.profile.indexNote": "Indexamos os resumos das suas atividades para um acesso rápido.",
  "tab.profile.viewIndex": "Ver índice",
  "tab.profile.sharedMaps": "Mapas partilhados",
  "tab.profile.sharedMapsNote": "Desativado: só você vê as suas atividades no Heatflask. Ativado: qualquer pessoa com uma ligação para o seu mapa vê as atividades que tornou públicas no Strava. As privadas continuam a ser só suas. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Como funciona a privacidade</a>",
  "tab.profile.logout": "Terminar sessão",
  "tab.profile.deleteAccount": "Eliminar conta",
  "tab.profile.deleteConfirm": "Eliminar a sua conta Heatflask?\n\nIsto remove as atividades indexadas e revoga o acesso do Heatflask aos seus dados do Strava. Não é possível anular.",
  "tab.profile.languageHeading": "Idioma",
  "tab.profile.languageAuto": "Automático",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Ajude-nos a corrigir ou a acrescentar traduções!</a>",
  "tab.profile.unitsHeading": "Unidades",
  "tab.profile.unitsAuto": "Automático",
  "tab.profile.unitsMetric": "Métrico (km, m)",
  "tab.profile.unitsImperial": "Imperial (mi, ft)",
  "tab.profile.textSizeHeading": "Tamanho do texto",
  "tab.profile.textSmaller": "Menor",
  "tab.profile.textReset": "Normal",
  "tab.profile.textLarger": "Maior",
  "tab.profile.mapDefaultsHeading": "Predefinições do mapa",
  "tab.profile.mapDefaultsNote": "Começar com este mapa base, relevo e definições de camada sempre que abrir um mapa cuja ligação não defina as suas. As ligações que partilha continuam a mostrar exatamente o que vê.",
  "tab.profile.mapDefaultsSave": "Guardar como as minhas predefinições",
  "tab.profile.mapDefaultsForget": "Esquecer",
  "tab.info.title": "Informações",
  "tab.info.controlsHeading": "Controlos",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + arrastar",
  "tab.info.shiftDragDesc": "Selecionar atividades dentro de um retângulo. Num ecrã tátil, toque primeiro em <i class=\"hf-object-group\"></i> e depois arraste com um dedo. A última atividade selecionada mostra os seus detalhes, e a lista desloca-se até ela.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + arrastar",
  "tab.info.ctrlDragDesc": "Rodar e inclinar o mapa em 3D, ou usar dois dedos",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Abrir ou fechar a barra lateral",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Separador anterior ou seguinte",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Fechar a barra lateral",
  "tab.info.liveUrlHeading": "URL em direto",
  "tab.info.liveUrlDesc": "A vista do mapa e as definições da animação ficam no URL da página, por isso quem receber a ligação vê exatamente o mesmo.",
  "tab.info.videoHeading": "Exportar vídeo",
  "tab.info.videoDesc": "O botão <i class=\"hf-video-camera\"></i> grava a animação em MP4: toque nele, ajuste o retângulo sobre a parte do mapa que quiser e toque novamente para gravar. É gravado um ciclo completo da animação, de modo que o vídeo se repete sem emendas; um ciclo com mais de {max} segundos (o vídeo mais longo que o Strava aceita) é cortado aos {max}.",
  "tab.info.contributeHeading": "Contribuir",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Patrocinar no GitHub",
  "tab.info.contactsHeading": "Contactos",
  "map.basemapAndTerrain": "Mapa base e relevo",
  "map.pauseAnimation": "Pausar a animação",
  "map.resumeAnimation": "Retomar a animação",
  "capture.record": "Gravar vídeo (ciclo de {period} s)",
  "capture.recordTruncated": "Gravar vídeo (um ciclo dura {period} s; só os primeiros {max} s serão gravados)",
  "capture.recordArea": "Gravar a área dentro do retângulo",
  "capture.stop": "Parar a gravação",
  "capture.selectionTooSmall": "a seleção é demasiado pequena",
  "capture.saved": "{name} guardado ({size})",
  "capture.cancelled": "gravação cancelada",
  "capture.failed": "falha na gravação: {error}",
  "capture.loadingEncoder": "a carregar o codificador…",
  "capture.waitingForMap": "à espera que o mapa carregue…",
  "capture.encoding": "a codificar… {percent} %",
  "capture.finalizing": "a finalizar…",
  "share.title": "Partilhar uma ligação para este mapa",
  "share.copied": "ligação copiada",
  "share.copiedUnshared": "ligação copiada — mas o seu mapa não está partilhado, por isso mais ninguém o consegue abrir. Ative «Mapas partilhados» para mudar isso.",
  "share.unshared": "O seu mapa não está partilhado, por isso mais ninguém consegue abrir esta ligação. Ative «Mapas partilhados» para mudar isso.",
  "share.copyThis": "Copie esta ligação:",
  "update.available": "Está disponível uma nova versão do Heatflask.",
  "update.reload": "Recarregar",
  "import.title": "A importar",
  "import.stop": "Parar",
  "import.stopping": "a parar…",
  "import.contacting": "a ligar ao Strava…",
  "import.countOf": "Atividades: {received} de {total}",
  "import.count": "Atividades: {received}",
  "import.waitStrava": "Em pausa até às {time} pelo limite de transferências do Strava. Deixe esta página aberta; recarregar não acelera.",
  "import.waitRationed": "As suas transferências rápidas de hoje esgotaram-se. O resto continua às {time}, mais devagar. Deixe esta página aberta.",
  "import.dailyLimit": "O limite diário de transferências do Strava esgotou-se. Tente novamente depois das {time}.",
  "import.dailyRationed": "Já usou a sua quota de transferências do Strava hoje. Tente novamente depois das {time}.",
  "import.noActivitiesYet": "A sua conta do Strava ainda não tem atividades. Grave ou carregue uma no Strava e ela aparecerá aqui.",
  "table.noActivities": "sem atividades",
  "table.untitled": "(sem título)",
  "activities.pageTitle": "{app} — índice de atividades",
  "activities.heading": "Índice de atividades",
  "activities.fetching": "A obter atividades...",
  "activities.rateLimit": "Limite de pedidos do Strava atingido; retoma às {time}",
  "activities.noData": "Lamentamos, não há dados &#128577;",
  "activities.colServerCache": "Traçado em cache no servidor (Mongo)",
  "activities.colBrowserCache": "Traçado em cache neste navegador",
  "activities.cachedServer": "O traçado de {id} está em cache no servidor",
  "activities.notCachedServer": "O traçado de {id} não está em cache no servidor",
  "activities.cachedBrowser": "O traçado de {id} está em cache neste navegador",
  "activities.notCachedBrowser": "O traçado de {id} não está em cache neste navegador",
  "sport.AlpineSki": "Esqui alpino",
  "sport.BackcountrySki": "Esqui de travessia",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basquetebol",
  "sport.Canoeing": "Canoagem",
  "sport.Cricket": "Críquete",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Dança",
  "sport.EBikeRide": "Volta de bicicleta elétrica",
  "sport.Elliptical": "Elíptica",
  "sport.EMountainBikeRide": "Volta de BTT elétrica",
  "sport.Golf": "Golfe",
  "sport.GravelRide": "Volta de gravel",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Caminhada na montanha",
  "sport.IceSkate": "Patinagem no gelo",
  "sport.InlineSkate": "Patins em linha",
  "sport.Kayaking": "Caiaque",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Volta de BTT",
  "sport.NordicSki": "Esqui de fundo",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fisioterapia",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Raquetebol",
  "sport.Ride": "Volta de bicicleta",
  "sport.RockClimbing": "Escalada",
  "sport.RollerSki": "Rollerski",
  "sport.Rowing": "Remo",
  "sport.Run": "Corrida",
  "sport.Sail": "Vela",
  "sport.Skateboard": "Skate",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Raquetas de neve",
  "sport.Soccer": "Futebol",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Máquina de escadas",
  "sport.StandUpPaddling": "Stand up paddle",
  "sport.Surfing": "Surf",
  "sport.Swim": "Natação",
  "sport.TableTennis": "Ténis de mesa",
  "sport.Tennis": "Ténis",
  "sport.TrailRun": "Trail",
  "sport.Velomobile": "Velomóvel",
  "sport.VirtualRide": "Volta de bicicleta virtual",
  "sport.VirtualRow": "Remo virtual",
  "sport.VirtualRun": "Corrida virtual",
  "sport.Volleyball": "Voleibol",
  "sport.Walk": "Caminhada",
  "sport.WeightTraining": "Musculação",
  "sport.Wheelchair": "Cadeira de rodas",
  "sport.Windsurf": "Windsurf",
  "sport.Workout": "Treino",
  "sport.Yoga": "Ioga"
}
